/* ============================================================
   K.NOAH — REVIEW EXPERIENCE V2
   Configuration only
   ============================================================ */

(function () {

  'use strict';

  if (window.KN_REVIEW_EXPERIENCE_V2) return;
  window.KN_REVIEW_EXPERIENCE_V2 = true;


  function enhanceReview() {

    var review =
      document.getElementById('kn57-review');

    if (!review) return false;


    /* ---------------------------------------------------------
       REMOVE LEGACY REQUEST FORM
       --------------------------------------------------------- */

    var oldRequest =
      document.getElementById('knr-request');

    if (oldRequest) {
      oldRequest.remove();
    }


    /* ---------------------------------------------------------
       CONFIGURATION ACCORDIONS
       --------------------------------------------------------- */

    review
      .querySelectorAll('.kn57-card > section')
      .forEach(function (section) {

        if (section.dataset.knAccordionBound === '1') {
          return;
        }

        var heading =
          section.querySelector('h4');

        if (!heading) return;

        section.dataset.knAccordionBound = '1';

        heading.setAttribute(
          'role',
          'button'
        );

        heading.setAttribute(
          'tabindex',
          '0'
        );

        heading.setAttribute(
          'aria-expanded',
          'false'
        );


        function toggle() {

          section.classList.toggle(
            'knr-config-open'
          );

          heading.setAttribute(
            'aria-expanded',
            section.classList.contains('knr-config-open')
              ? 'true'
              : 'false'
          );

        }


        heading.addEventListener(
          'click',
          toggle
        );


        heading.addEventListener(
          'keydown',
          function (event) {

            if (
              event.key === 'Enter' ||
              event.key === ' '
            ) {

              event.preventDefault();
              toggle();

            }

          }
        );

      });


    return true;

  }


  function install() {

    var reviewButton =
      document.querySelector(
        '#kn-part-switch-inner [data-kn-part="review"]'
      );


    if (!reviewButton) {
      return false;
    }


    if (
      reviewButton.dataset.knReviewV2Bound !== '1'
    ) {

      reviewButton.dataset.knReviewV2Bound = '1';


      reviewButton.addEventListener(
        'click',
        function () {

          setTimeout(
            enhanceReview,
            40
          );

          setTimeout(
            enhanceReview,
            150
          );

          setTimeout(
            enhanceReview,
            300
          );

        }
      );

    }


    setTimeout(
      enhanceReview,
      100
    );


    return true;

  }


  function init() {

    install();


    var attempts = 0;


    var timer =
      setInterval(
        function () {

          attempts++;

          install();

          enhanceReview();


          if (attempts >= 40) {

            clearInterval(
              timer
            );

          }

        },
        250
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();